import { render, staticRenderFns } from "./6.vue?vue&type=template&id=5bba81a0&scoped=true&"
import script from "./6.vue?vue&type=script&lang=js&"
export * from "./6.vue?vue&type=script&lang=js&"
import style0 from "./6.vue?vue&type=style&index=0&id=5bba81a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bba81a0",
  null
  
)

export default component.exports